import { css } from '@emotion/core';

const errorStyleOverrides = css`
  padding-left: 37px;
`;

const sepaButtonStyles = css`
  background: none;
  font-size: 13px;
  font-weight: 500;
  outline: none;
`;

export { errorStyleOverrides, sepaButtonStyles };
